<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title v-if="router === 'AddUser'"><h4 class="earth-color">REGISTER USER</h4></v-card-title>
      <v-card-title v-else><h4 class="earth-color">UPDATE USER</h4></v-card-title>
      <hr>
      <v-container>
        <v-form @submit.prevent="postUser()">
          <v-layout row wrap>
            <v-flex lg12 md12 sm12 xs12 v-if="localData.user_type_id !== '35fcfdaf'">
              <v-container fluid>
                <v-autocomplete label="User Type"
                                v-model="user.user_type"
                                :items="allUserTypes"
                                :rules="[v => !!v || 'Item is required']"
                                required
                                item-text="name"
                                item-value="public_id"
                                :return-object="true"
                                :loading="$loadingTrue"
                                @change="populateHasAccountData(user)"></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="First Name"
                              v-model="user.first_name"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Last Name"
                              v-model="user.last_name"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Email"
                              v-model="user.email"
                              :rules="requiredRules"
                              required
                              type="email"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Phone Number (e.g. 1-347382374)"
                              placeholder="code - number e.g. 1-347382374"
                              v-model="user.phone_number"
                              :rules="requiredRules"
                              required
                              type="tel"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12 v-if="user.has_account">
              <v-container>
                <v-text-field label="Customer Code (KES)"
                              v-model="user.customer_code_kes"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12 v-if="user.has_account">
              <v-container>
                <v-text-field label="Customer Code (USD)"
                              v-model="user.customer_code_usd"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container fluid>
                <v-btn :depressed="true" color="primary" type="submit" block v-if="router === 'AddUser'">Add User</v-btn>
                <v-btn :depressed="true" color="warning" type="submit" block v-else>Update User</v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
    {{UpdateUser}}
  </v-container>
</template>

<script>
  export default {
    name: 'add-user',
    data() {
      return {
        localData: JSON.parse(localStorage.getItem('unem')),
        requiredRules: [
          v => !!v || 'This field is required'
        ],
        router: this.$route.name,
        user: {
          partner_public_id: '',
          user_type: '',
          has_account: false,
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          customer_code_kes: '',
          customer_code_usd: '',
          session_id: localStorage.getItem('lkjhgfdsa'),
          public_id: this.$route.params.user_id
        }
      }
    },
    created() {
      this.$store.dispatch('get_all_user_types')
      if (this.router === 'AddUser') {
        this.user.customer_code_kes = '0000'
        this.user.customer_code_usd = '0000'
      }
      if (this.router !== 'AddUser') {
        this.$store.dispatch('get_user', this.$route.params.user_id)
      }
    },
    methods: {
      postUser: function () {
  if (this.router === 'AddUser') {
    if (this.localData.user_type_id === '35fcfdaf') {
      this.user.user_type = '35fcfdaf'
      this.user.partner_public_id = this.localData.instiution_id
      this.$store.dispatch('post_partner_user', this.user)
    } else {
      this.$store.dispatch('post_user', this.user)
    }
  } else {
    if (this.localData.user_type_id === '35fcfdaf') {
      this.user.user_type = '35fcfdaf'
      this.user.partner_public_id = this.localData.instiution_id
    } else {
      if (typeof this.user.user_type === 'object' && this.user.user_type !== null) {
        this.user.user_type = this.user.user_type.public_id
      }
    }
    this.$store.dispatch('update_user', this.user)
  }
},
      populateHasAccountData: function (userdets) {
        this.user.has_account = userdets.user_type.has_account


      }
    }
  }
</script>

<style>
</style>
